(() => {
  function updatePrice(form) {
    const variant = form.querySelector('[data-vl-variant]:checked');
    const summary = form.querySelector('[data-vl-summary]');
    const quantityInput = form.querySelector('[name="quantity"]');
    if (!variant || !summary || !quantityInput) return;
    const quantity = Number(quantityInput.value);
    if (!Number.isSafeInteger(quantity) || quantity < 1 || !quantityInput.validity.valid) return;
    const price = Number(variant.dataset.priceCents) * quantity;
    const comparison = Number(variant.dataset.compareCents) * quantity;
    const pouchCount = Number(variant.dataset.packCount) * quantity;
    if (![price, comparison, pouchCount].every(Number.isSafeInteger)) return;
    const saving = Math.max(0, comparison - price);
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: summary.dataset.currency
    });
    summary.querySelector('[data-vl-price]').textContent = formatter.format(price / 100);
    summary.querySelector('[data-vl-compare]').hidden = saving === 0;
    summary.querySelector('[data-vl-compare-value]').textContent = formatter.format(comparison / 100);
    summary.querySelector('[data-vl-saving]').hidden = saving === 0;
    summary.querySelector('[data-vl-discount-badge]').hidden = saving === 0;
    summary.querySelector('[data-vl-save-amount]').textContent = formatter.format(saving / 100);
    summary.querySelector('[data-vl-percent]').textContent = comparison > 0 ? Math.round(saving * 100 / comparison) : 0;
    const pouchCountDisplay = summary.querySelector('[data-vl-pouch-count]');
    if (pouchCountDisplay) pouchCountDisplay.textContent = pouchCount;
  }
  function onSelection(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-vl-variant], [name="quantity"]')) return;
    const form = input.closest('form');
    if (form) updatePrice(form);
  }
  document.addEventListener('input', onSelection);
  document.addEventListener('change', onSelection);
  function initialize(root) {
    root.querySelectorAll('form').forEach(updatePrice);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('pageshow', () => initialize(document));
})();
